import { PartnersStatuses, PartnersStatusesTranslate } from '@/enums';
import { BaseState } from '@/store/base-state';
import { Filters, TableOptions } from '@/types';
import { default_org } from '../services';
import {
  CompanyAccount,
  CompanyContract,
  DeliveryAddress,
  ModelContractsFilter,
  Organizations,
  TransportCompany,
  WebhookLog,
  Contract,
  WebhookObject,
} from '../types';

const default_user_org = (): Organizations.UserOrganization => ({
  address: '',
  name_company: '',
  partner_code: '',
  sigma_partner_code: '',
  frontol_partner_code: '',
  telephone: '',
  website: '',
  status: {
    slug: PartnersStatuses.DISTRIBUTOR,
    name: PartnersStatusesTranslate[PartnersStatuses.DISTRIBUTOR],
  },
  company_manager: {
    full_name: '',
    email: '',
    phone: '',
  },
  is_cert: false,
  company_roles: '',
  api_token: null,
  api_token_hidden: null,
  has_accredited_models: false,
  can_create_external_api_orders: true,
});

const default_contract = (): Contract => ({
  id: 0,
  number_contract: '',
  name_contract: '',
  contract_organization_title: '',
  type: '',
  pay_type: '',
  is_active: false,
  is_deferment_payment: false,
  limit: null,
  balance_limit: null,
  organization_id: null,
  balance_credit_limit: null,
});

export default class OrganizationState extends BaseState {
  user_orginazation: Organizations.UserOrganization = default_user_org();
  editable_user_orginazation: Organizations.UserOrganization = default_user_org();
  filters: Filters = {
    search: '',
    city: null,
    organization_type: [],
  };

  filters_active_contracts: ModelContractsFilter = {
    is_only_active: false,
  };

  organizations: Organizations.Organization[] = [];
  organizationsWithAscStatus: Organizations.Organization[] = [];
  current_organization: Organizations.Organization = default_org();
  delivery_addresses: DeliveryAddress[] = [];
  transport_companies: TransportCompany[] = [];
  company_accounts: CompanyAccount[] = [];
  company_contracts: CompanyContract[] = [];
  company_contracts_active_count = 0;
  sale_points: Organizations.SalePoint[] = [];
  cities: string[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['active_contracts'],
    sortDesc: [true],
  };

  api_key_message = '';
  api_key_message_toggle = false;

  webhook_logs: WebhookLog[] = [];
  webhook_logs_loading = false;
  webhook_error_message = '';

  webhook_objects: WebhookObject[] = [];

  current_contract: Contract = default_contract();
}
